import { Component, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { ProductReleaseService } from '../../services/ProductReleaseService';
import { Subscription } from 'rxjs/Subscription';
import { AdalService } from '../../shared/adal.service';
import { AppLoaderService } from '../../../services/app-loader/app-loader.service';

@Component({
    selector: 'dialog-result-example-dialog',
    template: require('./ViewAllChangeLog.component.html'),
})
export class PageLayoutAllChangeLog {
    private sub: Subscription;
    ProductId: any;
    changeLogData;
    Title: any;
    errorMessage: string;

    constructor(
        private router: Router,
        private adalService: AdalService,
        private appLoaderService: AppLoaderService,
        private productRelaseService: ProductReleaseService,
        public dialogRef: MdDialogRef<PageLayoutAllChangeLog>,
        @Inject(MD_DIALOG_DATA) public data: any) {
        document.body.style.overflow="hidden";
        //Check Authentication        
        if (!this.adalService.getCachedToken()) {
            document.body.style.overflow="auto";
            this.dialogRef.close();
            this.router.navigate(['login']);
        }
        this.ProductId = this.data.ProductId;
        if (this.data.SubProductName != '')
            this.Title = "All Release Change Logs of " + this.data.ProductName + " [" + this.data.SubProductName + "]";
        else
            this.Title = "All Release Change Logs of " + this.data.ProductName;
        this.getReleaseDetailById(this.data.ProductId);
    }

    getReleaseDetailById(ProductId: number) {
        this.appLoaderService.open();
        this.productRelaseService.getProductAllChangeLogDetails(ProductId).subscribe(
            data => {
                if (!data.IsError && data.DataObject != null) {
                    this.appLoaderService.close();
                    this.changeLogData = data.DataObject;
                }
                else {
                    this.changeLogData = null;
                }
            },
            _error => {
                this.appLoaderService.close();
            });
    }

    onCancel(): void {
        document.body.style.overflow="auto";
        this.dialogRef.close(true);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/view-product-changelog/viewallchangelog.component.ts